module.exports = __webpack_public_path__ + "static/media/ADA-BNB.44c59479.svg";